import { render, staticRenderFns } from "./UpdatePaymentMethod.vue?vue&type=template&id=a4537306&scoped=true&"
import script from "./UpdatePaymentMethod.vue?vue&type=script&lang=js&"
export * from "./UpdatePaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePaymentMethod.vue?vue&type=style&index=0&id=a4537306&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4537306",
  null
  
)

export default component.exports